import { render, staticRenderFns } from "./SlidePanel.vue?vue&type=template&id=20cb3940&"
import script from "./SlidePanel.vue?vue&type=script&lang=js&"
export * from "./SlidePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports